// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jb-0";